import { useHistory, useLocation } from 'react-router-dom';

import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import { Api } from 'src/models/Api.model';
import { getLocaleCode, Language } from 'src/models/Language.model';

import useUiTranslation from 'src/hooks/useUiTranslation';

import useCancelCaptureImages from './camera/useCancelCaptureImages';

export default function useCheckNavigation() {
  const { resetSession, setLeftUrl, setRightUrl, isCanceling, hasStarted } =
    useRemoteBoundStore();

  const { tPages, tCommon, language } = useUiTranslation();

  const history = useHistory();
  const location = useLocation();

  const { handleCancelCapture } = useCancelCaptureImages();

  const checkNavigation = (e: any) => {
    if (location.pathname === '/session-preview') {
      e.preventDefault(); // stop navigation

      Api.confirmBox({
        title: tCommon('bootbox.title.Confirm'),
        message: tPages('newExam.confirmExitImaging'),
        callback: (result) => {
          if (!result) {
            return;
          }

          if (!isCanceling && hasStarted) {
            handleCancelCapture();
          }

          setLeftUrl('');
          setRightUrl('');
          resetSession();

          let path;
          if (e.target.href) {
            path = e.target.href.split('#')[1];
          } else {
            const navLink = e.target.closest('a');
            path = navLink?.getAttribute('href')?.split('#')[1];
          }

          if (path) {
            history.push(path);
          }
        },
        locale: getLocaleCode(language as Language),
      });
    }
  };

  return { checkNavigation };
}
